import { ButtonBase } from './ButtonBase';
import styled from 'styled-components';

export const DefaultButton = styled(ButtonBase)`
  background: rgba(44, 44, 44, 0.5);
  color: #fff;
`;
